import React from "react";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { Link } from "react-router-dom";

const Avatar = props => {
  let { uri, id } = props;

  if (uri == null) {
    return <Link to={`/lead/${id}`}><PersonAddIcon style={{ fontSize: 40 }} /></Link>;
  } else {
    return <img src={ uri } style={{width: 40, borderRadius: '50%'}} alt="avatar" />;
  }
};

export default Avatar;
